<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead" id="pa01"><a id="page23">
<h2 class="partTitle" style="text-indent: 0%;">Ambulance Ship</h2>
<div class="partEpigraph">
<p class="partEpigraphText" style="text-indent:0%;">T<span class="smallCaps">O</span> J<span class="smallCaps">ACK</span> C<span class="smallCaps">OHEN</span><br/> <span class="smallCaps">WHO IS A STICKLER FOR XENOBIOLOGICAL VERISIMILITUDE,</span><br/> <span class="smallCaps">IN APPRECIATION</span></p></div>
</a></div><a id="page23">
<div class="partBody">
</div>
</a></div>
<a id="page23">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312877705_pt01.vue?3d335398